import { useEffect } from 'react';

/** First visit on The Hub: start the spotlight tour once. Help can replay it. */
export function HubTourAutoStart() {
  useEffect(() => {
    void import('./hubTour')
      .then(({ hasSeenHubTour, startHubTour }) => {
        if (hasSeenHubTour()) return;
        const timer = window.setTimeout(() => {
          if (hasSeenHubTour()) return;
          startHubTour();
        }, 400);
        return () => window.clearTimeout(timer);
      })
      .catch(() => {});
  }, []);

  return null;
}
